module.exports = __webpack_public_path__ + "img/details_new.81259482.png";